import styled from 'styled-components';

export const Version = styled.span`
  color: ${({ theme }) => theme.color.additional.alwaysWhite.value};
  font-size: 18px;
  font-weight: 300;
  margin-left: auto;
`;
